import "react-app-polyfill/ie11";
import "react-app-polyfill/stable";
import React from "react";
import { render } from "react-dom";
import { ApolloClient, InMemoryCache } from "@apollo/client";
import { ApolloProvider } from "@apollo/client";
import JetMinds from "./JetMinds";
import "./index.css";
import * as serviceWorker from "./serviceWorker";

const client = new ApolloClient({
  uri: "https://api-eu-central-1.graphcms.com/v2/ckl2mxhl4ufif01z85yjr0afe/master",
  cache: new InMemoryCache({ resultCaching: true }),
});

function App() {
  return (
    <ApolloProvider client={client}>
      <div>
        <JetMinds />
      </div>
    </ApolloProvider>
  );
}

render(<App />, document.getElementById("root"));

serviceWorker.unregister();



// WEBPACK FOOTER //
// ./src/index.js